<div style="padding-bottom: 16px;">
    <div class="repeat-section">

        <div class="d-flex flex-column justify-content-center section2">
            <div class="eac-body-2 valign-center" style=" min-height: 36px; width: 80%;">
                {{metadata().name}} 
            </div>
            <div class=" valign-center eac-c1 ">
                <quill-view-html [content]="metadata().description"></quill-view-html>
            </div>
            <div  *ngIf="!metadata().atLeastOne">
                <mat-checkbox (change)="checkTableStatus($event.checked)">{{metadata().addLabel}}</mat-checkbox>
            </div>
            
        </div>

        <table #formTable mat-table [dataSource]="dataSource" [class.mat-elevation-z8]="dataSource.data.length > 0" [class.d-none]="dataSource.data.length == 0">

            <ng-container [matColumnDef]="fieldChild.id!" *ngFor="let fieldChild of getFields(); let i = index;" style="padding-top: 16px;">
                        
                <th mat-header-cell *matHeaderCellDef>{{fieldChild.props!['label2']}}</th>
                <td mat-cell *matCellDef="let element">
                    <formly-field [field]="getFieldById(element, fieldChild.id!)"></formly-field>
                </td>

            </ng-container>

            <ng-container matColumnDef="delete">
                <th mat-header-cell *matHeaderCellDef>
                    <button mat-icon-button type="button" (click)="add($event)" matTooltip="Esborrar" class="btn btn-default">
                        <mat-icon class="material-icons-outlined">add</mat-icon>
                    </button>
                </th>
                <td mat-cell *matCellDef="let element; let i = index">
                    <button *ngIf="metadata().atLeastOne == null || metadata().atLeastOne == false || (metadata().atLeastOne==true &&i>0) " mat-icon-button type="button" (click)="remove(i)" matTooltip="Esborrar" class="btn btn-default">
                        <mat-icon class="material-icons-outlined">delete</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="getDisplayColumns(); sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: getDisplayColumns()"></tr>

        </table>
                
        <!--
        <div class="d-flex justify-content-start notprint " style="margin-bottom: 10px;">

            <div style="padding-top: 8px;">
                <div  (click)="add($event)" class="d-flex align-items-center add-repeat " style="gap:8px;">
                    <mat-icon style="font-size: 18px; height: 18px; width: 18px;  ">add</mat-icon>
                    <span class="valign-center mat-body-strong" style="padding-left: 4px;">{{metadata().addLabel}}</span>
                </div>
            </div>
            
        </div>
        -->
    </div>
</div>